import { GridColumnProps, LinkColumn } from '@roc/ui';
import { observer } from 'mobx-react';
import { useLoanStore } from '@roc/feature-loans';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import {
  filterProps,
  noOpComparator
} from '@roc/ui/utils';
import { InfiniteScrollGrid } from '@roc/feature-app-core';
import { formatPhoneNumber } from '@roc/ui/utils';

export const foreclosureLoansColumns: GridColumnProps[] = [
  {
    field: 'dealid',
    headerName: 'Loan Id',
    minWidth: 100,
    maxWidth: 125,
    cellRenderer: 'loanIdCellRenderer',
    comparator: noOpComparator,
    ...filterProps(),
    pinned: 'left',
    lockPinned: true,
  },
  {
    field: 'lenderType',
    headerName: 'Lender Type',
    minWidth: 125,
    comparator: noOpComparator,
    ...filterProps(),
  },
  {
    field: 'maturityStatus',
    headerName: 'Status',
    minWidth: 140,
    comparator: noOpComparator,
    ...filterProps(),
  },
  {
    field: 'dealName',
    headerName: 'Deal Name',
    minWidth: 375,
    comparator: noOpComparator,
    ...filterProps(),
  },
  {
    field: 'borrowerName',
    headerName: 'Borrower Name',
    minWidth: 225,
    comparator: noOpComparator,
    ...filterProps(),
  },
  {
    field: 'borrowerPhone',
    headerName: 'Borrower Phone',
    minWidth: 175,
    cellRenderer: 'phoneCellRenderer',
    comparator: noOpComparator,
    ...filterProps(),
  },
  {
    field: 'borrowerEmail',
    headerName: 'Borrower Email',
    minWidth: 225,
    comparator: noOpComparator,
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender Name',
    minWidth: 225,
    comparator: noOpComparator,
    ...filterProps(),
  },
  {
    field: 'closingDate',
    headerName: 'Closing Date',
    minWidth: 150,
    comparator: noOpComparator,
    ...filterProps(),
  },
  {
    field: 'maturityDate',
    headerName: 'Maturity Date',
    minWidth: 150,
    comparator: noOpComparator,
    ...filterProps(),
  },
];

export const MaturityLoansDashboard = observer(() => {
  const { loanRoutesConfig } = useLoanRoutes();
  const { loanStore } = useLoanStore();

  const frameworkComponents = {
    loanIdCellRenderer: params => {
      const loanId = params.node.data?.dealid;
      return LinkColumn({
        ...params,
        url: loanRoutesConfig.loans(loanId).children.dashboard.url,
      });
    },
    phoneCellRenderer: ({ value }) => formatPhoneNumber(value),
  };

  return (
    <InfiniteScrollGrid
      columns={foreclosureLoansColumns}
      store={loanStore.maturityLoansGridStore}
      frameworkComponents={frameworkComponents}
    />
  );
});
